import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './MatrixExplanation.scss';

const MatrixExplanation: React.FC = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="matrix-explanation">
      <button
        type="button"
        className="matrix-explanation__toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <h3 className="matrix-explanation__title">{t('matrix.howTo.title')}</h3>
        <span className="matrix-explanation__icon">{isOpen ? '−' : '+'}</span>
      </button>

      {isOpen && (
        <div className="matrix-explanation__content">
          <section className="matrix-explanation__section">
            <h4>{t('matrix.howTo.calculationTitle')}</h4>
            <p>{t('matrix.howTo.calculationIntro')}</p>
            <ul>
              <li>{t('matrix.howTo.calculationStep1')}</li>
              <li>{t('matrix.howTo.calculationStep2')}</li>
              <li>{t('matrix.howTo.calculationStep3')}</li>
              <li>{t('matrix.howTo.calculationStep4')}</li>
            </ul>
          </section>

          <section className="matrix-explanation__section">
            <h4>{t('matrix.howTo.digitsTitle')}</h4>
            <p>{t('matrix.howTo.digitsIntro')}</p>
            <div className="matrix-explanation__digits">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                <div key={n} className="matrix-explanation__digit">
                  <span className="matrix-explanation__digit-num">{n}</span>
                  <span className="matrix-explanation__digit-meaning">{t(`matrix.howTo.digit${n}`)}</span>
                </div>
              ))}
            </div>
          </section>

          <section className="matrix-explanation__section">
            <h4>{t('matrix.howTo.readingTitle')}</h4>
            <p>{t('matrix.howTo.readingIntro')}</p>
            <ul>
              <li><strong>{t('matrix.howTo.readingCount0')}</strong> — {t('matrix.howTo.readingCount0Text')}</li>
              <li><strong>{t('matrix.howTo.readingCount1')}</strong> — {t('matrix.howTo.readingCount1Text')}</li>
              <li><strong>{t('matrix.howTo.readingCount2')}</strong> — {t('matrix.howTo.readingCount2Text')}</li>
              <li><strong>{t('matrix.howTo.readingCount3')}</strong> — {t('matrix.howTo.readingCount3Text')}</li>
            </ul>
            <p className="matrix-explanation__lines">{t('matrix.howTo.linesIntro')}</p>
            <ul>
              <li><strong>1-4-7</strong> — {t('matrix.howTo.line147')}</li>
              <li><strong>2-5-8</strong> — {t('matrix.howTo.line258')}</li>
              <li><strong>3-6-9</strong> — {t('matrix.howTo.line369')}</li>
            </ul>
          </section>
        </div>
      )}
    </div>
  );
};

export default MatrixExplanation;
